import React, { Fragment } from 'react'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import Textarea from 'react-textarea-autosize'
import fetchJSON from 'lib/fetchJSON'
import PropTypes from 'prop-types'

export const SEND_MESSAGE_DIALOG = 'SEND_MESSAGE_DIALOG'

export class SendMessage extends React.PureComponent {
  static propTypes = {
    toUser: PropTypes.object.isRequired
  }

  state = {
    subject: '',
    message: '',
    sendPending: false,
    error: null
  }

  onConfirm = (e) => {
    e && e.preventDefault()
    // sending messages is fire-and-forget unless it errors
    const { toUser, currentUserId, onRequestClose } = this.props
    const { subject, message } = this.state
    this.setState({ sendPending: true })
    fetchJSON(`/users/${currentUserId}/conversations.json`, {
      recipient_id: toUser.id,
      subject,
      message
    }).then(() => {
      this.setState({ sendPending: false, error: null }, onRequestClose)
    }).catch(() => {
      this.seState({ sendPending: false, error: 'An error occurred - please try again or contact support if the error persists' })
    })
  }

  render () {
    const { message, subject, sendPending, error } = this.state
    const { toUser, onRequestClose } = this.props

    return (
      <ConfirmationDialog
        primary
        title={<Fragment>Send message to <strong>{toUser.name}</strong></Fragment>}
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.onConfirm}
        confirmPending={sendPending}
        confirmText='Send Message'>
        <form onSubmit={this.onConfirm}>
          <label>Subject</label>
          <input autoFocus type='text' value={subject} onChange={e => this.setState({ subject: e.target.value })} />
          <label>Message</label>
          <Textarea value={message} minRows={3} onChange={e => this.setState({ message: e.target.value })} />
          {error && <p>{error}</p>}
        </form>
      </ConfirmationDialog>
    )
  }
}
